var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgHumberger(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 34,
    height: 34,
    viewBox: "0 0 34 34",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0 3.4C0 1.52223 1.52223 0 3.4 0C5.27777 0 6.8 1.52223 6.8 3.4C6.8 5.27777 5.27777 6.8 3.4 6.8C1.52223 6.8 0 5.27777 0 3.4Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M13.6 3.4C13.6 1.52223 15.1222 0 17 0C18.8778 0 20.4 1.52223 20.4 3.4C20.4 5.27777 18.8778 6.8 17 6.8C15.1222 6.8 13.6 5.27777 13.6 3.4Z",
    fill: "white"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M27.2 3.4C27.2 1.52223 28.7222 0 30.6 0C32.4778 0 34 1.52223 34 3.4C34 5.27777 32.4778 6.8 30.6 6.8C28.7222 6.8 27.2 5.27777 27.2 3.4Z",
    fill: "white"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M0 17C0 15.1222 1.52223 13.6 3.4 13.6C5.27777 13.6 6.8 15.1222 6.8 17C6.8 18.8778 5.27777 20.4 3.4 20.4C1.52223 20.4 0 18.8778 0 17Z",
    fill: "white"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M13.6 17C13.6 15.1222 15.1222 13.6 17 13.6C18.8778 13.6 20.4 15.1222 20.4 17C20.4 18.8778 18.8778 20.4 17 20.4C15.1222 20.4 13.6 18.8778 13.6 17Z",
    fill: "white"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M27.2 17C27.2 15.1222 28.7222 13.6 30.6 13.6C32.4778 13.6 34 15.1222 34 17C34 18.8778 32.4778 20.4 30.6 20.4C28.7222 20.4 27.2 18.8778 27.2 17Z",
    fill: "white"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M0 30.6C0 28.7222 1.52223 27.2 3.4 27.2C5.27777 27.2 6.8 28.7222 6.8 30.6C6.8 32.4778 5.27777 34 3.4 34C1.52223 34 0 32.4778 0 30.6Z",
    fill: "white"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M13.6 30.6C13.6 28.7222 15.1222 27.2 17 27.2C18.8778 27.2 20.4 28.7222 20.4 30.6C20.4 32.4778 18.8778 34 17 34C15.1222 34 13.6 32.4778 13.6 30.6Z",
    fill: "white"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M27.2 30.6C27.2 28.7222 28.7222 27.2 30.6 27.2C32.4778 27.2 34 28.7222 34 30.6C34 32.4778 32.4778 34 30.6 34C28.7222 34 27.2 32.4778 27.2 30.6Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHumberger);
export default __webpack_public_path__ + "static/media/Humberger.c9c49244f82e08e3d4574471db0b293b.svg";
export { ForwardRef as ReactComponent };